var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultBlogBanner(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1169,
    height: 319,
    viewBox: "0 0 1169 319",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_551_1132)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1169,
    height: 319,
    rx: 20,
    fill: "#CA3657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.713 96.0472L486.621 156.132L490.711 162.959L492.075 156.132L517.985 108.337L532.986 123.358L528.895 121.992C526.167 121.992 526.167 121.992 524.804 124.723C523.713 126.908 533.44 133.827 538.441 137.013H546.623L543.895 152.034L547.987 156.132L554.805 142.476L565.715 156.132C567.897 151.763 579.352 147.938 584.807 146.572L562.987 134.282L576.624 127.454L572.533 124.723L556.169 127.454V120.627C553.896 116.075 548.805 106.698 546.623 105.605C544.441 104.513 542.986 106.971 542.532 108.337V112.433L528.895 98.7776L576.624 71.4664L584.807 70.1008L573.897 67.3697L515.258 85.122L486.621 59.1771C472.984 52.3493 477.075 63.2738 479.803 68.736C481.985 73.1058 497.986 88.7642 505.713 96.0472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_551_1132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474 262.257C475.857 255.449 487 239.975 516.714 232.548C522.286 158.27 626.286 102.563 695 176.844",
    stroke: "white",
    strokeWidth: 4.84384,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 970.709,
    cy: 340.287,
    r: 212.635,
    transform: "rotate(-13.0969 970.709 340.287)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 793.965,
    cy: 232.891,
    r: 109.084,
    transform: "rotate(-13.0969 793.965 232.891)",
    fill: "white",
    fillOpacity: 0.2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1168,
    height: 318,
    rx: 19.5,
    stroke: "#E2E7F5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_551_1132",
    x: 467.34,
    y: 137.529,
    width: 237.953,
    height: 137.444,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.81644,
    dy: 4.23836
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.0274
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.501961 0 0 0 0 0.501961 0 0 0 0 0.501961 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_551_1132"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_551_1132",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_551_1132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1169,
    height: 319,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultBlogBanner);
export default __webpack_public_path__ + "static/media/default_blog_banner.f296b547077551c9bc3dce5c78ed7a85.svg";
export { ForwardRef as ReactComponent };